import { IAdFoxBannerOnLoadData } from '@cian/adfox-component';
import * as React from 'react';

import { AdfoxNew } from '../adfox/adfoxNew';
import { ADFOX_MEDIA_BANNER_LABEL, ADFOX_NEW_MEDIA_CONSTANTS } from '../adfox/constants';

import { Marquee } from './Marquee';
import { mergeStyles } from '@cian/utils';

import * as styles from './SearchBlock.css';

interface ISearchBlockProps {
  backgroundNode: React.ReactNode;
  isNewFilters: boolean;
  mediaNote?: string;
  section: string;
  onLoadAdfox?(context: IAdFoxBannerOnLoadData): void;
  onStubAdfox?(): void;
}

export const SearchBlock: React.FC<React.PropsWithChildren<ISearchBlockProps>> = ({
  backgroundNode,
  children,
  isNewFilters,
  mediaNote,
  section,
  onLoadAdfox,
  onStubAdfox,
}) => {
  const isDailyRent = section === 'daily-rent';

  React.useEffect(() => {
    /* на посуточной не нужна реклама */
    if (isDailyRent) {
      if (onStubAdfox) {
        onStubAdfox();
      }
    }
  }, [onStubAdfox, isDailyRent]);

  return (
    <div
      data-testid="SearchBlock"
      {...mergeStyles(
        styles['c-filters'],
        isNewFilters && styles['c-filters--new'],
        isDailyRent && styles['c-filters-dailyrent'],
      )}
    >
      <div className={styles['c-filters-content']}>
        <div className={styles['c-filters-inner']}>
          {children}
          <Marquee mediaNote={mediaNote} hasNewPlacement={isNewFilters} />
        </div>
        {/* на посуточной не нужна реклама */}
        {!isDailyRent && (
          <AdfoxNew
            postViewAnalyticsData={{
              place: 'filters_background',
              place__DEPRECATED: `home_${section}`,
              name__DEPRECATED: ADFOX_MEDIA_BANNER_LABEL,
            }}
            constants={ADFOX_NEW_MEDIA_CONSTANTS}
            onLoad={onLoadAdfox}
            onStub={onStubAdfox}
          />
        )}
      </div>
      <div className={styles['background']}>{backgroundNode}</div>
    </div>
  );
};
